import axios, { AxiosError } from 'axios';
import { ErrorEmitter } from './ErrorEmitter';

export const generateError = (msg: string, code: string = 'GEN', emit = true): void => {
    if (!emit) {
        console.error(code, `Generated Error: ${msg}`);
        return;
    }
    ErrorEmitter.emit(code, `Generated Error: ${msg}`);
};

export class Error {
    code: string = null;

    message: string = null;

    constructor(code: string, message: string) {
        this.code = code;
        this.message = message;
    }
}

export const generateErrorNoEmit = (msg: string, code: string = 'GEN') => generateError(msg, code, false);

export const getErrorStatus = (error: any): number | undefined => error?.response?.status;

export const SESSION_LISTING_FORBIDDEN_CODES = ['use_case_listing_forbidden', 'replay_depth'];

export const isSessionListingForbidden = (error: any): boolean => {
    const data = error?.response?.data;
    const codes: string[] = [data?.code, ...(Array.isArray(data?.errors) ? data.errors.map((e: any) => e?.code) : [])];

    return codes.some((code) => SESSION_LISTING_FORBIDDEN_CODES.includes(code));
};

export const FETCH_NETWORK_FAILURE_MESSAGES = [
    'Load failed',
    'Failed to fetch',
    'NetworkError when attempting to fetch resource',
    'The Internet connection appears to be offline',
    'The network connection was lost',
];

export const isNetworkFailure = (exception: any): boolean => {
    if (exception?.name === 'AbortError' || exception?.name === 'TimeoutError') {
        return true;
    }

    const message = exception?.message;

    // matched whole rather than by substring, so that errors which merely embed one of these phrases
    // still reach Sentry - notably "Failed to fetch dynamically imported module", the stale chunk
    // a client hits after a deploy
    return typeof message === 'string' && FETCH_NETWORK_FAILURE_MESSAGES.some((entry) => message === entry || message === `${entry}.`);
};

export const captureException = (exception: AxiosError | Error) => {
    const SENTRY_EXCLUDED_ERROR_CODES = [400, 401, 403, 404];

    const AXIOS_NETWORK_ERROR_MESSAGE = 'Network Error';

    if (isNetworkFailure(exception)) {
        return false;
    }

    if (axios.isAxiosError(exception)) {
        if (axios.isCancel(exception)) {
            return false;
        }

        if (SENTRY_EXCLUDED_ERROR_CODES.includes(exception?.response?.status)) {
            return false;
        }

        if (exception.message === AXIOS_NETWORK_ERROR_MESSAGE) {
            return false;
        }
    }

    return true;
};
